export interface StatisticAnalysisRangeSelectorState {
    value: boolean
}
export const initialStatisticAnalysisRangeSelectorState =
    (): StatisticAnalysisRangeSelectorState => ({
        value: false
    })
